import { render, staticRenderFns } from "./PublicationList.vue?vue&type=template&id=0ca64ae2&"
import script from "./PublicationList.vue?vue&type=script&lang=js&"
export * from "./PublicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports